import { OperatorType } from "@/components/Workflows/WorkflowCanvas/Canvas/ContextMenu/Conditions/constants";
import { ConditionCondition } from "@/types/evaluate";

const defaultUnaryRightConfig = {
  type: "static_value" as const,
  static_value: "",
};

export const normalizeConditionForOperator = (
  condition: ConditionCondition,
  operator: ConditionCondition["operator"],
): ConditionCondition => {
  if (operator === OperatorType.IS_NULL || operator === OperatorType.IS_NOT_NULL) {
    return {
      ...condition,
      operator,
      right_config: defaultUnaryRightConfig,
    };
  }

  return {
    ...condition,
    operator,
  };
};
